<div class="route-component">
    <div class="form-component">

        <tab-control>
            <tab-page title="Declaration Reports" icon="fas fa-user-pen">
                <h4>
                    Select Report
                </h4>

                <form #form="ngForm" (ngSubmit)="onRunReport(form)">
                    <!-- Period -->
                    <div class="input-group">
                        <auto-complete-dropdown
                            [options]="periods"
                            [label]="'Period'"
                            [placeholder]="'Select a period...'"
                            [initialValue]="selectedPeriodId"
                            [required]="true"
                            [invalid]="!selectedPeriodId && formSubmitted"
                            [validationMessage]="'Period is required'"
                            [displayWith]="displayPeriod"
                            (selectionChange)="onPeriodSelectionChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Client -->
                    <div class="input-group">
                        <auto-complete-dropdown
                            [options]="clients"
                            [label]="'Client'"
                            [placeholder]="'Select a client...'"
                            [initialValue]="selectedClientId"
                            [required]="true"
                            [invalid]="!selectedClientId && formSubmitted"
                            [validationMessage]="'Client is required'"
                            (selectionChange)="onClientSelectionChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Policy -->
                    <div class="input-group" *ngIf="selectedClientId && clientAreas && clientAreas.length">
                        <auto-complete-dropdown
                            [options]="clientAreas"
                            [label]="'Policy'"
                            [placeholder]="'Select a policy...'"
                            [initialValue]="selectedClientAreaId"
                            [required]="true"
                            [invalid]="!selectedClientAreaId && formSubmitted"
                            [validationMessage]="'Policy is required'"
                            (selectionChange)="onClientAreaSelectionChange($event)"
                            (blur)="getReportsForLookup()">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Report -->
                    <div class="input-group" *ngIf="selectedClientAreaId && reports && reports.length">
                        <auto-complete-dropdown
                            [options]="reports"
                            [label]="'Report'"
                            [placeholder]="'Select a report...'"
                            [initialValue]="selectedReportId"
                            [required]="true"
                            [invalid]="!selectedReportId && formSubmitted"
                            [validationMessage]="'Report is required'"
                            (selectionChange)="onReportSelectionChange($event)">
                        </auto-complete-dropdown>
                    </div>

                    <!-- Action Bar -->
                    <div class="action-bar">
                        <button type="submit" class="button" [disabled]="form.invalid || isSaving">
                            <span *ngIf="isSaving" class="loading-spinner"></span>
                            <i *ngIf="!isSaving" class="fas fa-fire"></i>
                            Run Report
                        </button>
                    </div>
                </form>
            </tab-page>
        </tab-control>

    </div>
</div>